import request from "../service/request";
export function login(data) {
  return request({
    url: "/login",
    // url: "/api/login",
    headers: {
      isToken: false,
      repeatSubmit: false,
    },
    method: "post",
    data,
  });
}

export function getInfo(data) {
  return request({
    url: "/getInfo",
    // url: "/api/getInfo",
    method: "get",
    data,
  });
}

export function dataList(data) {
  return request({
    // url: "/api/asset/dataList/list",
    url: "/asset/dataList/list",
    method: "get",
    params: data,
  });
}
export function addList(data) {
  return request({
    // url: "/api/asset/dataList",
    url: "/asset/dataList",
    method: "post",
    data,
  });
}
export function UpdatePwd(data) {
  return request({
    url: "/system/user/profile/updatePwd",
    // url: "/api/system/user/profile/updatePwd",
    method: "put",
    headers: {
      isToken: true,
      repeatSubmit: true,
    },
    data,
  });
}
export function addJob(data) {
  return request({
    url: "/system/post",
    // url: "/api/system/post",
    method: "post",
    data,
  });
}

export function listUser(data) {
  return request({
    url: "/other/contentUpload/list",
    // url: "/api/other/contentUpload/list",
    method: "get",
    params: data,
    usedev: true, // 添加此标志切换到王鑫的接口地址
  });
}
export function getDeptTreeLists(params) {
  return request({
    url: "/system/dept/tree",
    // url: "/api/system/dept/tree",
    method: "get",
    params,
  });
}
export const getSubsidiaryTree = (params) => {
  return request({
    url: "/system/dept/subsidiaryTree",
    // url: "/api/system/dept/subsidiaryTree",
    method: "get",
    params,
  });
};
export const loginw = () => {
  return request({
    url: "/user/getWXToken",
    // url: "/api/user/getWXToken",
    // headers: {
    //   isToken: false,
    //   repeatSubmit: false,
    //   "content-type": "application/json",
    // },
    method: "get",
    usedev: true, // 添加此标志切换到王鑫的接口地址
  });
};
export const getWenDangDetail = (id) => {
  return request({
    url: "/other/contentUpload/" + id,
    method: "get",
    usedev: true, // 添加此标志切换到王鑫的接口地址
  });
};
export const getaddViews = (id) => {
  return request({
    url: "/other/contentUpload/addviews/" + id,
    method: "get",
    usedev: true, // 添加此标志切换到王鑫的接口地址
  });
};
